<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div v-if="resData" style="padding: 10px 25px">
              <el-form ref="form" :model="form" label-width="85px">
                <el-row :gutter="10">
                  <el-col>
                    <el-form-item label="输入搜索：">
                      <el-col :span="2">
                        <el-input
                          v-model="form.admin_name"
                          placeholder="代采员"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <el-select
                          v-if="resData"
                          v-model="form.pgid"
                          placeholder="代采组"
                          filterable
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in resData.option.pgOption"
                            :key="item.key1"
                            :value="item.key1"
                            :label="item.label"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="2">
                        <el-select
                          v-if="resData"
                          v-model="form.role_type"
                          placeholder="角色"
                          filterable
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in resData.option.roleOption"
                            :key="item.key"
                            :value="item.key"
                            :label="item.label"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="3">
                        <el-select
                          v-if="resData"
                          v-model="form.city"
                          placeholder="城市"
                          filterable
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in resData.option.cityOption"
                            :key="item.key"
                            :value="item.key"
                            :label="item.label"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="3">
                        <el-select
                          v-if="resData"
                          v-model="form.status"
                          placeholder="状态"
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="(item, index) in resData.option.statusOption"
                            :key="index"
                            :label="item.label"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="2">
                        <el-button type="primary" @click="search">
                          查询</el-button
                        >
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          v-if="resData"
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据汇总 ：{{ resData.count }}人</div>
          <el-button
            style="margin-left: auto"
            type="warning"
            size="mini"
            @click="AddMember(0)"
            >添加人员
          </el-button>
          <el-button type="success" size="mini" @click="output">导出</el-button>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="purchase_group_member_city"
              label="城市"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="pgname" label="代采组" align="center">
              <template slot-scope="scope">
                <p
                  v-for="(item, index) in hanlePg(scope.row.pgname)"
                  :key="index"
                >
                  {{ item }}
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="admin_name" label="代采员" align="center">
            </el-table-column>
            <el-table-column
              prop="purchase_group_member_role_type"
              label="角色"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_num"
              label="绑定商家数量"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.supply_num > 0"
                  type="text"
                  @click="handleClick(scope.row.pg_member_id)"
                  >{{ scope.row.supply_num }}</el-button
                >
                <span v-if="scope.row.supply_num == 0">{{
                  scope.row.supply_num
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="buyer_version"
              label="代采版本"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="storage_version"
              label="仓储版本"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="mobile"
              label="手机号码"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="wx_nick_name"
              label="微信昵称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="purchase_group_member_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column prop="" label="操作" align="center" width="100">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="AddMember(scope.row.pg_member_id)"
                  >编辑</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="showLogList(scope.row.pg_member_id)"
                  >操作日志
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div v-if="showlog">
      <log :id="id" :log-type="log_type" @onCloseDialog="closeBox"></log>
    </div>
    <div v-if="showbox">
      <edit-member :id="id" @onCloseDialog="closeBox"></edit-member>
    </div>
  </div>
</template>

<script>
import Log from "./components/Log.vue";
import EditMember from "./components/EditMember";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    Log,
    EditMember,
  },
  data() {
    return {
      log_type: 2,
      id: 0,
      showlog: false,
      showbox: false,
      images: [],
      resData: null,
      form: {
        status: "",
        pgid: "",
      },
      loading: false, // 加载动画是否显示
      url: "/erp/PurchaseGroup/purchaseGroupMember",
      status: "",
      curPage: 1,
      loading: false,
      tableLoading: false,
      filterFold: false,
      picker: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    const { pgid } = this.$route.query;
    if (pgid != "undefined" && pgid != null && pgid != "" && pgid) {
      this.form.pgid = pgid;
    }
    this.fetchData();
  },
  methods: {
    hanlePg(data) {
      if (!data) {
        return [];
      }
      const re = data.split(",");
      return re;
    },
    handleClick(id) {
      this.$router.push(`/home/supply/supplyList?pg_member_id=${id}`);
    },
    showLogList(id) {
      this.id = Number(id);
      this.showlog = true;
    },
    AddMember(id) {
      this.id = Number(id);
      this.showbox = true;
    },
    closeBox() {
      this.showbox = false;
      this.showlog = false;
      this.fetchData();
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.fetchData();
    },
    selectStatus(key) {
      this.form.status = this.status = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.demo-form-inline .el-form-item {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/purchasegroup/Member.vue